/**
 * Clase para representar una lista de items
 */
export default class ScopedItemProperties {
  /** @type {string} */ key = 'key'
  /** @type {string} */ label = 'label'
  /** @type {string} */ items = 'items'
  /** @type {string} */ status = 'status'
  /** @type {string} */ statuslabel = 'statuslabel'
}
